import { gql } from '@apollo/client';

const createSystemProvider = gql`
  mutation CreateSystemProvider($variables: SystemProviderInput!) {
    createSystemProvider(input: $variables) {
      id
      name
      recipient_email
      is_active
      createdAt
      updatedAt
    }
  }
`;
export default createSystemProvider;
